import { Paper } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

const ChartCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2)
}))

export default ChartCard
